import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OptTaskDetails } from '../../../classes/models/admin/OptTaskDetails';
import { OptTaskDetailsAdapter } from '../../../classes/adapters/response/admin/OptTaskDetailsAdapter';
import { OptTaskDetailsResponse } from '../../../interfaces/response/AdminPageResponses';

/**
 * This service communicates with backend to manage all administrative tasks.
 */
@Injectable({
  providedIn: 'root'
})
export class OptimisationTaskService {
  private http = inject(HttpClient);
  private optTaskDetailsAdapter = inject(OptTaskDetailsAdapter);

  url = environment.apiUrl + '/admin';

  /**
   * Retrieves a list of optimisation task details.
   */
  getOptTasksDetails(): Observable<OptTaskDetails[]> {
    const url = `${this.url}/tasks/optimisation/details`;
    return this.http.get(url).pipe(
      map((data: OptTaskDetailsResponse[]) => data.map(this.optTaskDetailsAdapter.adapt)));
  }

  /**
   * Disables all optimisation tasks at once.
   */
  disableAllOptTask(): Observable<void> {
    const url = `${this.url}/task/optimisation/disable`;
    return this.http.post<void>(url, {});
  }

  /**
   * Disables optimisation task for the given store.
   * @param storeId an identifier of a store.
   */
  disableOptTask(storeId: string): Observable<void> {
    const url = `${this.url}/task/optimisation/disable/${storeId}`;
    return this.http.post<void>(url, {});
  }

  /**
   * Enables optimisation tasks for all stores.
   */
  enableAllOptTasks(): Observable<void> {
    const url = `${this.url}/task/optimisation/enable`;
    return this.http.post<void>(url, {});
  }

  /**
   * Enables optimisation task for the given store.
   * @param storeId an identifier of a store
   */
  enableOptTask(storeId: string): Observable<void> {
    const url = `${this.url}/task/optimisation/enable/${storeId}`;
    return this.http.post<void>(url, {});
  }

  /**
   * Resets all optimisation tasks.
   */
  resetAllOptTasks(): Observable<void> {
    const url = `${this.url}/task/optimisation/reset`;
    return this.http.post<void>(url, {});
  }

  /**
   * Reset the optimisation task for the given store.
   * @param storeId an identifier of a store.
   */
  resetOptTask(storeId: string): Observable<void> {
    const url = `${this.url}/task/optimisation/reset/${storeId}`;
    return this.http.post<void>(url, {});
  }
}
